import React, { useMemo, useState } from 'react';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi, DateTimePickerUI } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';
import dayjs from 'dayjs';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import taskProdGanttService from '../../service/taskProdGantt.service';

const ProductionStore = ({ user, refetch, canEdit }) => {
  const [rows, setRows] = useState({ rows: [], rowCount: 0 });
  const { productionChanged, setProductionChanged } = refetch;

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'baseDocNum', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  const getProdOperations = (gridState) => {
    taskProdGanttService.getProductionsForStore(gridState).then((data) => {
      setRows(data);
    });
  };

  const updateProduction = (id, startDate) => {
    const values = {
      id,
      updatedBy: user.userId,
      startDate,
    };
    taskProdGanttService.updateProductionFromStore(values).then(() => {
      setProductionChanged(true);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'workingNumber',
        headerName: 'GYU. szám',
        type: 'string',
      },
      {
        field: 'reference',
        headerName: 'Vevőhivatkozási szám',
        type: 'string',
      },
      {
        field: 'doc_joker_date1',
        headerName: 'Logisztikai határidő',
        type: 'date',
        valueGetter: (_data, row) => {
          return row.doc_joker_date1 ? new Date(row.doc_joker_date1) : null;
        },
        renderCell: (data) => {
          return data.row.doc_joker_date1 ? dayjs(data.row.doc_joker_date1).format('YYYY.MM.DD') : '';
        },
      },
      {
        field: 'endDate',
        headerName: 'Határidő',
        type: 'date',
        valueGetter: (_data, row) => {
          return row.endDate ? new Date(row.endDate) : null;
        },
        renderCell: (data) => {
          return data.row.endDate ? dayjs(data.row.endDate).format('YYYY.MM.DD') : '';
        },
      },
      {
        field: 'companyName',
        headerName: 'Cég',
        type: 'string',
        renderCell: (data) => {
          return data.row?.company?.name;
        },
      },
      {
        field: 'startDate',
        headerName: 'GY. tervezett kezdete',
        type: 'dateTime',
        editable: true,
        valueGetter: (_data, row) => {
          return row?.startDate ? new Date(row.startDate) : null;
        },
        renderCell: (data) => {
          return data?.row?.startDate ? dayjs(data.row.startDate).format('YYYY.MM.DD HH:mm') : '';
        },
        renderEditCell: (data) => {
          return (
            <DateTimePickerUI
              variant="standard"
              value={dayjs(data.row?.startDate)}
              onChange={(newDate) => {
                if (!newDate) {
                  addNotification({
                    content: 'A mező értéke nem törölhető!',
                    type: NotificationType.ERROR,
                  });
                } else {
                  const dateObject = newDate?.toDate();
                  data.api.setEditCellValue({
                    id: data.id,
                    field: data.field,
                    value: dateObject,
                  });
                }
              }}
            />
          );
        },
      },
      {
        field: 'button',
        type: 'string',
        filterable: false,
        headerName: 'Tervezés',
        renderCell: (params) => {
          return (
            <ButtonUI
              text="Tervezés"
              size="sm"
              className="py-1.5 px-2.5 bg-success"
              disabled={!canEdit}
              onClick={() => updateProduction(params.row.id, params.row.startDate)}
            />
          );
        },
      },
    ]);
  }, []);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.productionStore}
      datagridInitialState={initialState}
      dataLoader={getProdOperations}
      refetch={{ refetchTable: productionChanged, setRefetchTable: setProductionChanged }}
      rowCount={rows.rowCount}
      columns={[...columns]}
      rows={rows.rows}
      paginationAndfilterMode="server"
      hideFooter
    />
  );
};

export default ProductionStore;
